import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Users, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

/* Accept a Family Space invitation (verified account linking). */
export default function FamilyAccept() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const { user, loading } = useAuth();
  const nav = useNavigate();
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) { setErr("This invitation link is missing its code."); return; }
    api.get("/family/invite-info", { params: { token } })
      .then((r) => setInfo(r.data))
      .catch((e) => setErr(e.response?.data?.detail || "Invitation not found or already used."));
  }, [token]);

  const accept = async () => {
    setBusy(true);
    try {
      await api.post("/family/accept", { token });
      toast.success("Welcome to the family space!");
      nav("/my-social-pulse?tab=family");
    } catch (e) { toast.error(e.response?.data?.detail || "Could not accept the invitation"); }
    setBusy(false);
  };

  return (
    <div className="max-w-md mx-auto px-5 py-16 text-center" data-testid="family-accept-page">
      <Users className="w-10 h-10 text-violet-700 mx-auto" />
      <h1 className="font-heading font-900 text-2xl mt-3">Family Space invitation</h1>
      {err ? (
        <p className="mt-3 text-sm text-zinc-600" data-testid="family-accept-error">{err}</p>
      ) : !info ? (
        <p className="mt-3 text-sm text-zinc-500">Checking invitation…</p>
      ) : (
        <>
          <p className="mt-3 text-sm text-zinc-600" data-testid="family-accept-info">
            <b>{info.inviter}</b> invited <b>{info.name}</b> ({info.email}) to join their private family space — shared memories, important dates and, soon, the family tree.
          </p>
          {loading ? <p className="mt-4 text-sm text-zinc-500">Checking your sign-in…</p> : user ? (
            <button onClick={accept} disabled={busy} data-testid="family-accept-btn"
              className="mt-5 inline-flex items-center gap-2 bg-violet-700 text-white font-700 px-6 py-3 rounded-full hover:bg-violet-600 disabled:opacity-50">
              {busy && <Loader2 className="w-4 h-4 animate-spin" />} Accept invitation
            </button>
          ) : (
            <p className="mt-4 text-sm text-zinc-600">Please <Link to="/login" className="text-blue-700 font-700 underline">sign in or create your free account</Link>, then open this link again.</p>
          )}
          <p className="mt-4 text-[11px] text-zinc-400">You always control what you share, and you can leave the space at any time.</p>
        </>
      )}
    </div>
  );
}
